import React from "react";
import OutsideClickHandler from "react-outside-click-handler";
import cx from "classnames";
import isString from "lodash/isString";
import moment from "moment";
import PropTypes from "prop-types";

import { DateTimeButton, DateTimeInput, DateTimePicker } from ".";

import styles from "./DateTime.css";

const stringToDate = (date) => (date ? moment(date).toDate() : undefined);

const formatDate = (date) => (isString(date) ? date : moment(date).format("YYYY-MM-DD"));
const formatTime = (time) => (isString(time) ? time : moment(time).format("HH:mm"));

export default class DateTime extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.isOpen || false,
      date: stringToDate(props.date || props.dates[0]),
      time: props.time,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDateTime = this.handleChangeDateTime.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  handleChange(attr, val) {
    this.setState({ [attr]: val }, () => {
      if (this.props.isTimeHidden && attr === "date") this.handleSave();
    });
  }

  handleChangeDateTime(dateTime) {
    const date = formatDate(dateTime);
    const time = formatTime(dateTime);

    this.setState({ date, time });
    this.props.onSave({ date, time });
  }

  handleClose() {
    this.setState({ isOpen: false });
  }

  handleOpen() {
    this.setState({ isOpen: true });
  }

  handleReset() {
    this.setState({ date: "", time: "", isOpen: false });
    this.props.onSave({ date: null, time: null });
  }

  handleSave() {
    const { date, time } = this.state;
    this.handleClose();
    this.props.onSave({ date: formatDate(date), time: formatTime(time) });
  }

  render() {
    const { date, isOpen, time } = this.state;
    const { align, isInput, isRequired, isTimeHidden, label, title } = this.props;

    return (
      <div className={styles.root}>
        {isInput ? (
          <DateTimeInput
            date={date}
            isRequired={isRequired}
            isTimeHidden={isTimeHidden}
            onChange={this.handleChange}
            onChangeDateTime={this.handleChangeDateTime}
            onClick={this.handleOpen}
          />
        ) : (
          <DateTimeButton
            date={date}
            isTimeHidden={isTimeHidden}
            label={label}
            onChange={this.handleChange}
            onChangeDateTime={this.handleChangeDateTime}
            onClick={this.handleOpen}
            time={time}
          />
        )}
        {isOpen && (
          <div
            className={cx(styles.picker, {
              [styles.right]: align === "right",
              [styles.input]: isInput,
            })}
          >
            <OutsideClickHandler onOutsideClick={this.handleSave}>
              <DateTimePicker
                date={date}
                isTimeHidden={isTimeHidden}
                onChange={this.handleChange}
                onClose={this.handleClose}
                onReset={this.handleReset}
                onSave={this.handleSave}
                time={time}
                title={title}
              />
            </OutsideClickHandler>
          </div>
        )}
      </div>
    );
  }
}

DateTime.propTypes = {
  align: PropTypes.oneOf(["left", "right"]),
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  dates: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])),
  label: PropTypes.string,
  time: PropTypes.string,
  title: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  isInput: PropTypes.bool,
  isOpen: PropTypes.bool,
  isRequired: PropTypes.bool,
  isTimeHidden: PropTypes.bool,
};

DateTime.defaultProps = {
  align: "left",
  date: "",
  time: "",
  dates: [],
};
